export const GET_SRT_STATS = 'GET_SRT_STATS';
export const GET_SRT_STATUS = 'GET_SRT_STATUS';
export const START_STREAM = 'START_STREAM';
export const STOP_STREAM = 'STOP_STREAM';
export const GET_STREAMS = 'GET_STREAMS';
export const IMPORT_STREAMS = 'IMPORT_STREAMS';
export const BACKUP_FILES = 'BACKUP_FILES';
export const EXPORT_STREAMS = 'EXPORT_STREAMS';
export const SAVE_NEW_STREAM = 'SAVE_NEW_STREAM';
export const DELETE_STREAM = 'DELETE_STREAM';
export const PREVIEW_STREAM = 'PREVIEW_STREAM';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const GET_NICS = 'GET_NICS';
export const GET_ABOUT = 'GET_ABOUT';
export const GET_STREAM = 'GET_STREAM';
export const SAVE_NETWORK_SETTINGS = 'SAVE_NETWORK_SETTINGS';
export const RESET_PWD = 'RESET_PWD'
export const GET_LOCALCONFIG = 'GET_LOCALCONFIG';
export const GET_SSH_STATUS = 'GET_SSH_STATUS';
export const GET_PEER_IP = 'GET_PEER_IP';
export const CLEAR_TSTABLE_REPORT = 'CLEAR_TSTABLE_REPORT';
export const GET_TSTABLE_REPORT_INPUT = 'GET_TSTABLE_REPORT_INPUT';
export const GET_TSTABLE_REPORT_OUTPUT = 'GET_TSTABLE_REPORT_OUTPUT';
export const GET_STREAM_STATS = 'GET_STREAM_STATS';
export const SET_SELECTED_CONTAINER = 'SET_SELECTED_CONTAINER';
export const GET_SERVER_ACTION = 'GET_SERVER_ACTION';
export const GET_CONFIG_ACTION = 'GET_CONFIG_ACTION';
